import { combineReducers } from "redux";
import productReducer from "./features/Product/reducer";
import cartReducer from "./features/Cart/reducer";

const rootReducer = combineReducers({
  product: productReducer,
  cart: cartReducer,
});

export default rootReducer;
